import i18n from "i18next";
import {initReactI18next} from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    lt: {
        translation: {
            "TepaloFiltras": "Tepalo filtras",
            "OroFiltras": "Oro filtras (išorinis)",
            "OroFiltrasVid": "Oro filtras (vidinis)",
            "HidroFiltras": "Padavimo srauto hidraulio filtras",
            "DegaluFiltras": "Degalų filtras",
            "KabinosFiltras": "Kabinos filtras",
            "KondicFiltras": "Kondicionieriaus filtras",
            "PirmValFiltras": "Degalų pirminio valymo filtras",
            "ADBlueFiltras": "DEF/\"ADBlue\" filtras",
            "KartIsleidHidrFiltras": "Grįžtamojo srauto hidraulio filtras",

            "VariklioTepalas": "Variklio tepalas",
            "HidraulioTepalas": "Hidraulinis tepalas",
            "TransmisiojosTepalas": "Transmisijos tepalas",
            "PavarosTepalas": "Pavarų tepalas 80W/90",
            "AsiuDifSkysciai": "Ašių ir diferrencialų skysčiai",
            "PavaruDezesSkystis": "Pavarų dėžės skystis",
            "SuteptTepimoTaskai": "Sutepti tepimo taškai",
            "Antifrizas": "Antifrizas",
            "LanguSkystis": "Langų skystis",


            "Other": "Kita",
            "GeneratoriausDirzas": "Generatoriaus diržas",
            "RezervAlsGaub": "Rezervuaro alsuoklio gaubtelis",

            "Count": "Kiekis (litrais)",

            "VehiclePlateNumber": "RW numeris",
            "LastChangedDate": "TA aptarnavimo data",
            "LastChangedValue": "Atliktas TA prie",
            "NextMaintenance": "Kitas aptarnavimas po",

            "Comment": "Komentaras",
            "test": "Testas"
        }
    },
    ru: {
        translation: {
            "TepaloFiltras": "Фильтр масла",
            "OroFiltras": "RU.Oro Filtras",
            "test": "Тестссс"
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "lt",
        fallbackLng: "lt",
        debug: true,

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;